import {
  Grid,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Typography,
} from "@mui/material";
import React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { noticeToCreditorsFlow } from "../index";
import * as Yup from "yup";
import { Formik, FormikHelpers } from "formik";
import { OUTCOMES, SCREEN_PATHS } from "../../../constants";
import { ScreenFlowFormButtons } from "../shared/ScreenFlowFormButtons";
import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";

interface Values {
  probateCourt: string;
}

export const ProbateCourtScreen = (): JSX.Element => {
  const navigate = useNavigate();
  const { screenName } = useParams();
  const currentScreen = noticeToCreditorsFlow.getCurrentFlowScreen(screenName);

  // https://formik.org/docs/api/formik
  const formikInit = {
    values: {
      probateCourt: "",
    },
    schema: Yup.object().shape({
      probateCourt: Yup.string().required(),
    }),
  };

  const handleSubmit = async (
    values: Values,
    { setSubmitting, setStatus }: FormikHelpers<Values>
  ) => {
    setStatus("");
    try {
      if (!currentScreen) throw Error("couldn't determine currentScreen");

      // TODO: save to database

      noticeToCreditorsFlow.navigateToNext(
        currentScreen,
        OUTCOMES.complete,
        navigate
      );
    } catch (error) {
      setStatus("Sorry, error: " + ((error as Error)?.message || ""));
      // console.error(error);
      setSubmitting(false);
    }
  };

  return currentScreen ? (
    <FlowScreenWrapper
      title="Based on [Jacob]’s address, we located the correct Probate Court for the estate"
      subTitle="Please confirm that this is the correct probate court for the domicile estate. That’s just a fancy legal word for primary personal residence."
    >
      <Formik
        initialValues={formikInit.values}
        validationSchema={formikInit.schema}
        onSubmit={handleSubmit}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          touched,
          values,
          status,
        }) => (
          <form onSubmit={handleSubmit}>
            <Grid
              container
              spacing={5}
              sx={{
                my: 1,
              }}
            >
              <Grid item xs={12}>
                <FormControl style={{ width: "100%" }}>
                  <InputLabel>Probate Court</InputLabel>
                  <Select
                    name="probateCourt"
                    error={Boolean(touched.probateCourt && errors.probateCourt)}
                    label="Probate Court"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.probateCourt}
                  >
                    <MenuItem value="pitt_county_probate_court">
                      Pitt County Probate Court
                    </MenuItem>
                    <MenuItem value="king_county_probate_court">
                      King County Probate Court
                    </MenuItem>
                    <MenuItem value="sam_county_probate_court">
                      Sam County Probate Court
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Link
                  to={`${SCREEN_PATHS.flow}/${noticeToCreditorsFlow.flowPath}/estate-property`}
                  style={{ textDecoration: "none" }}
                >
                  <Typography variant="body1">I don’t know</Typography>
                </Link>
              </Grid>
              <Grid item xs={12}>
                <ScreenFlowFormButtons
                  isSubmitting={isSubmitting}
                  status={status}
                  onBack={() => navigate(-1)}
                />
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </FlowScreenWrapper>
  ) : (
    <></>
  );
};
